<template>
  <span class="ui-badge" :class="`ui-badge--${tone}`">
    <slot />
  </span>
</template>

<script>
export default {
  name: "UiBadge",
  props: {
    tone: { type: String, default: "neutral" },
  },
};
</script>

<style scoped>
.ui-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  white-space: nowrap;
}

.ui-badge--neutral {
  background: rgba(148, 163, 184, 0.16);
  color: var(--text);
  border-color: rgba(148, 163, 184, 0.32);
}

.ui-badge--success {
  background: rgba(34, 197, 94, 0.18);
  color: var(--color-success);
  border-color: rgba(34, 197, 94, 0.4);
}

.ui-badge--warning {
  background: rgba(245, 158, 11, 0.16);
  color: #fbbf24;
  border-color: rgba(245, 158, 11, 0.35);
}

.ui-badge--danger {
  background: rgba(239, 68, 68, 0.16);
  color: var(--color-danger);
  border-color: rgba(239, 68, 68, 0.4);
}

.ui-badge--info {
  background: rgba(56, 189, 248, 0.16);
  color: var(--color-accent);
  border-color: rgba(56, 189, 248, 0.4);
}
</style>
